import { render } from "./asset-status.vue?vue&type=template&id=512274b1&scoped=true"
import script from "./asset-status.vue?vue&type=script&lang=js"
export * from "./asset-status.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-512274b1"

export default script